import { GridFilterModule } from './grid-filter-module';

class CustomNoRowsOverlay {
  private eGui: HTMLElement;
  init(params: {
    filterModule: GridFilterModule;
    noFilteredResultsMessage?: string;
    noResultsMessage?: string;
  }) {
    this.eGui = document.createElement('div');
    const { filterModule, noFilteredResultsMessage, noResultsMessage } = params;
    if (filterModule.isFilterApplied()) {
      this.eGui.innerHTML = `<span class="no-filtered-results-message">${noFilteredResultsMessage}</span>`;
    } else {
      this.eGui.innerHTML = `<span class="no-results-message">${noResultsMessage}</span>`;
    }
  }

  refresh() {
    return false;
  }

  getGui() {
    return this.eGui;
  }
}

export { CustomNoRowsOverlay };
